import axios from "axios";

const baseUrl = "/api/SiteSearch";
class SiteSearchService {

    private language: string;

    public constructor(language: string) {
        this.language = language;
    }

    public getSearchResults(query: string, pageNumber: number, pageSize: number) {
        const encodedQuery = encodeURI(query);
        return axios.get<ISiteSearchData>(`${baseUrl}/Search?query=${encodedQuery}&language=${this.language}&page=${pageNumber}&pageSize=${pageSize}`)
            .then((response) => response.data);
    }
}

interface IServerResponse {
    data: ISiteSearchData;
}

interface ISiteSearchData {
    totalCount: number;
    results: ISiteSearchResult[];
}

interface ISiteSearchResult {
    text: string;
    url: string;
    isFile: boolean;
    mimeType: string;
    size: number;
}
export { SiteSearchService, ISiteSearchResult };
